module.exports = __webpack_public_path__ + "img/Orbiting-2.b079ee7a.png";